import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { AccountManager, getActiveForms, NotificationManager } from '@atlas/core';
import { onForgotPasswordSubmit, useActiveForm } from '@atlas/react-forms';
import { Icon, Label } from '@atlas/ui';

import FormWithCaptcha from 'common/Form/FormWithCaptcha/FormWithCaptcha';
import { useHidePopupSignUpDelay } from 'hooks/useHidePopupSignUpDelay';
import { useSetNextShowPopupSignUpDelay } from 'hooks/useSetNextShowPopupSignUpDelay';
import { customSignupFormRules } from 'src/helpers/customFormRules';

export const PHONE_RESET_TYPE = 'PHONE';

const ForgotPassword = () => {
  const history = useHistory();
  const { activeType, submit } = useActiveForm(
    'INIT_PASSWORD_RESET',
    onForgotPasswordSubmit(AccountManager.initPasswordResetWithForm.bind(AccountManager)),
    getActiveForms,
  );

  const formConfig = activeType?.steps[0];
  const realFormConfig = useMemo(() => {
    if (formConfig) {
      return {
        ...formConfig,
        fields: formConfig.fields.map(field => ({
          ...field,
          ...customSignupFormRules(field),
        })),
      };
    }
    return formConfig;
  }, [formConfig]);

  const onBackButtonClick = useCallback(() => {
    return history.length === 1 ? history.push('/') : history.goBack();
  }, [history]);

  const submitHandler = useCallback(
    (...props) =>
      submit(...props).then(response => {
        if (response.resetType === PHONE_RESET_TYPE) {
          history.push(`/resetPassword?formType=${PHONE_RESET_TYPE}&token=${response.publicToken}`);
          return;
        }

        NotificationManager.notify({
          message: 'reset_password_sended',
          status: 'success',
          type: 'notification',
        });

        onBackButtonClick();
      }),
    [history, submit, onBackButtonClick],
  );

  useHidePopupSignUpDelay();
  useSetNextShowPopupSignUpDelay();

  return (
    <div className="auth forgot-password">
      <div className="header">
        <button className="top-button back-button" onClick={onBackButtonClick}>
          <Icon className="icon-back" name="back" />
        </button>
        <Label message="forgot_password" />
      </div>
      <div className="content">
        <Label message="we_will_send_you_reset_link" />
        {activeType && (
          <FormWithCaptcha
            action={submitHandler}
            buttonText="restore_password"
            form={realFormConfig}
            formType={activeType}
          />
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
